import { useRef } from 'react'
import { useBreakpoints } from '@10000/react'
import { Body, Button, Card, ElementHighlight, H4, useTooltipSeries } from '../widgets'
import { practices } from '../../lookups'
import { assetUrl } from '../../utilities.js'
import './PracticeDetailsCard.scss'

export const PracticeDetailsCard = ({ displayMode, practice, onClick, onClose }) => {
  const { name, description } = practices[practice] || {}
  const practiceCard = useRef()
  const { constrained } = useBreakpoints()
  const { tip } = useTooltipSeries()

  return (
    <>
      <Card
        ref={practiceCard}
        column
        width={328}
        rotate={-3}
        background="var(--blue)"
        p={24}
        gap={8}
        onClose={(!displayMode && tip !== 4) && onClose}
        className={`practice-details-card${displayMode ? ' display' : ''}`}
      >
        <H4>{name}</H4>
        {name && <img src={assetUrl(`practices/${name.toLowerCase()}.png`)} />}
        {description?.map?.((text, i) =>
          <Body key={i} lineHeight="24px">
            {text}
          </Body>
        )}
        {!displayMode &&
          <Button onClick={onClick}>
            Learn more
          </Button>
        }
      </Card>

      {!constrained && <ElementHighlight
        order={4}
        target={practiceCard}
        pointDirection={constrained ? 'down' : 'left-down'}
        nextOnFinish
      />}
    </>
  )
}